var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFullscreenExit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 13c-1.093 0-2 .907-2 2v4h2v-4h4v-2zM1 13v2h4v4h2v-4c0-1.093-.907-2-2-2zM13 1v4c0 1.093.907 2 2 2h4V5h-4V1zM5 1v4H1v2h4c1.093 0 2-.907 2-2V1z"
})));
export default SvgIconFullscreenExit;